import React, { useContext, useEffect, useState } from "react";
import MainMemberInfo from "../../../components/UserViewFormComponents.js/MainMemberInfo";
import ResidenceInfo from "../../../components/UserViewFormComponents.js/ResidenceInfo";
import VillageAddress from "../../../components/UserViewFormComponents.js/VillageAddress";
import OfficeInformation from "../../../components/UserViewFormComponents.js/OfficeInformation";
import DependentsInfo from "../../../components/UserViewFormComponents.js/DependentsInfo";
import { constantTypes } from "../../../utils/constants/constant";
import { useForm, useFieldArray } from "react-hook-form";
import { Button } from "bootstrap";
import AuthContext from "../../../hooks/context/AuthContext";
// import SuccessCheck from "../../components/shared/Loader/SuccessCheck";
import { Loader } from "lucide-react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { ViewUsersApi } from "../../../hooks/ApisContainer/User";
import useToastContext from "../../../hooks/useToastContext";
import { useParams } from "react-router-dom";
import LottiLoader from "../../../components/shared/Loader/LottiLoader";

const UserView = () => {
  let { handleRegister, loading, signupSuccess } = useContext(AuthContext);
  const { id } = useParams();
  const notification = useToastContext();
  // HOOK FORM
  const {
    control,
    register,
    setValue,
    clearErrors,
    watch,
    setError,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      familyInformation: [constantTypes.familyInformation],
    },
  });

  // ALL STATE

  const [officePhone, setOfficePhone] = useState("");
  const [dobDate, setDobDate] = useState("");
  const [familyMemberDOB, setFamilyMemberDOB] = useState([]);
  const [dateError, setDateError] = useState("");
  const [familyMemberDOBError, setFamilyMemberDOBError] = useState([]);
  const [FamilyPhone, setFamilyPhone] = useState([]);
  const { fields, append, remove } = useFieldArray({
    control,
    name: "familyInformation",
  });
  const [user, setUser] = useState({});
  const [memberInfo, setMemberInfo] = useState({});
  const [loader, setLoader] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Lifetime");
  const [profilePic, setProfilePic] = useState(
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRzJtv72esjEWvfSpkux9LhOEGiBQ5vuR8drQ&s"
  );
  const [profileFile, setProfileFile] = useState(null);

  const handleChangeDate = (dates, index) => {
    setDobDate(...dates);
    dateValidation(...dates, dobDate);
  };

  const handleChangeFamilyMemberDate = (dates, index) => {
    const newFamilyMemberDOB = [...familyMemberDOB];
    newFamilyMemberDOB[index] = dates[0];
    setFamilyMemberDOB(newFamilyMemberDOB);
    dateValidation(...dates, newFamilyMemberDOB, index);
  };

  const handleProfileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const blobURL = URL.createObjectURL(file);
      setProfilePic(blobURL);
      setProfileFile(file);
    }
  };

  const dateValidation = (date, dateTwo, index, isTrue = false) => {
    let dateError = "";
    let familyMemberDobErr = "";

    if (!date) {
      dateError = "Date field is required.";
    } else {
      dateError = "";
    }

    if (familyMemberDOB[index]) {
      familyMemberDobErr = "Date field is required.";
    } else {
      familyMemberDobErr = "";
    }

    if (dateError) {
      setDateError(dateError);
      if (index !== -1) {
        const newFamilyMemberDOBError = [...familyMemberDOBError];
        newFamilyMemberDOBError[index] = familyMemberDobErr;
        setFamilyMemberDOBError(newFamilyMemberDOBError);
      } else if (isTrue) {
        setFamilyMemberDOBError(
          fields.map((el, i) =>
            familyMemberDOB[i] ? "" : "Date field is required."
          )
        );
      }
      return false;
    } else {
      setDateError(dateError);
      if (index !== -1) {
        const newFamilyMemberDOBError = [...familyMemberDOBError];
        newFamilyMemberDOBError[index] = familyMemberDobErr;
        setFamilyMemberDOBError(newFamilyMemberDOBError);
      }
      return true;
    }
  };

  const fetchedGetUsers = () => {
    const requestPayload = { id };
    ViewUsersApi(requestPayload, notification, (loading, error, response) => {
      setLoader(loading);
      if (!error) {
        setUser(response);
      }
    });
  };

  useEffect(() => {
    fetchedGetUsers();
  }, []);

  useEffect(() => {
    setMemberInfo({
      memberName: `${user.firstName} ${user.lastName}`,
      mobile: user.mobile,
      email: user.email,
      dob: user.dob,
      placeOfBirth: user.placeOfBirth,
      typeOfBrahman: user.type,
      gotra: user.gotra,
      gender: user.gender,
      referencePerson: user.referencePerson,
      belongFrom: user.villageName,
      membershipType: user?.membershipType,
    });
  }, [user]);

  return (
    <div className="d-flex justify-content-center align-items-center w-100">
      {loader ? (
        <Row className="d-flex justify-content-center align-items-center ">
          <Col md={12}>
            <Container className="d-flex justify-content-center align-items-center default-back w-100">
              <span>
                <LottiLoader height={120} width={120} loader={true} />
              </span>
            </Container>
          </Col>
        </Row>
      ) : (
        <section
          className="registration-form-sec"
          style={{ padding: "0px 0px" }}
        >
          <Container>
            <Form
              className="p-md-4 p-sm-2 px-0 text-start"
              noValidate
              autoComplete="off"
            >
              <div className="login-sec d-block pt-0 mb-2">
                <MainMemberInfo memberInfo={memberInfo} loader={loader} />
                <ResidenceInfo currentAddressData={user} loader={loader} />
                <VillageAddress villageAddressData={user} loader={loader} />
                <OfficeInformation
                  OfficeInformationData={user}
                  loader={loader}
                />
                <DependentsInfo
                  DependentsInfoData={user}
                  fields={fields}
                  append={append}
                  remove={remove}
                />
              </div>
            </Form>
          </Container>
        </section>
      )}
    </div>
  );
};

export default UserView;
